import React, { useEffect, useState } from 'react'
import { Snackbar, Alert } from '@mui/material'
import { TOAST_EVENT } from '../../utils/toast'

export default function ToastHost() {
  const [current, setCurrent] = useState(null)

  useEffect(() => {
    const handler = (event) => {
      const detail = event && event.detail
      if (!detail || !detail.message) return
      setCurrent({
        key: Date.now(),
        severity: detail.severity || 'info',
        message: detail.message,
      })
    }
    window.addEventListener(TOAST_EVENT, handler)
    return () => window.removeEventListener(TOAST_EVENT, handler)
  }, [])

  const handleClose = (_event, reason) => {
    if (reason === 'clickaway') return
    setCurrent(null)
  }

  return (
    <Snackbar
      key={current ? current.key : 'idle'}
      open={!!current}
      autoHideDuration={5000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      {current ? (
        <Alert
          onClose={handleClose}
          severity={current.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {current.message}
        </Alert>
      ) : undefined}
    </Snackbar>
  )
}
